import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { BorderColor } from '@material-ui/icons'
import history from '~/config/history'
import { ROUTES } from '~/views/routes'

const SectorsButton = ({ layout, locationId }) => {
  return (
    <Button
      onClick={() => {
        history.push(
          ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.INDEX.replace(
            ':locationId',
            locationId
          ).replace(':layoutId', layout.Id)
        )
      }}>
      <Typography>{layout !== null ? layout.SectorsCount : '0'}</Typography>
      &nbsp;&nbsp;
      <BorderColor />
    </Button>
  )
}

export default SectorsButton
